import React from 'react'

export default class Spinner extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            show: true
        }
    }

    render () {
        return (
            <div className='rtf-spinner-wrapper'>
                <div className='rtf-spinner-content'>

                    {/* loading icon */}
                    {this.props.spinnerState === 'sync' &&
                        <svg className='rtf-spinner-icon rtf-spinner-icon--loading' fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82 81">
                            <path d="M76.559 76.324V54.007H73.96m0 0A35.712 35.712 0 0 1 5.419 45.08m68.542 8.927H54.24M5.143 4.908v22.317h2.593m0 0a35.721 35.721 0 0 1 68.546 8.928M7.736 27.226H27.46" stroke="#1C75BC" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    }

                    {/* success icon */}
                    {this.props.spinnerState === 'success' &&
                        <svg className='rtf-spinner-icon rtf-spinner-icon--success' fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108 109">
                            <rect x="4" y="4" width="100" height="100" rx="52.446" stroke="#3CB81D" strokeWidth="8"/>
                            <path d="m20.828 56.531 13.06 13.06a1.923 1.923 0 0 0 2.717 0l8.254-8.253m22.428-22.43L54.471 51.726" stroke="#3CB81D" strokeWidth="6" strokeLinecap="round"/>
                            <path d="M38.445 54.93 53.107 69.59a1.922 1.922 0 0 0 2.717 0L86.506 38.91" stroke="#3CB81D" strokeWidth="6" strokeLinecap="round"/>
                        </svg>
                    }

                    {/* error icon */}
                    {this.props.spinnerState === 'error' &&
                        <svg className='rtf-spinner-icon rtf-spinner-icon--success' fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108 109">
                            <path
                                d="M104 54c0-27.6142-22.3858-50-50-50S4 26.3858 4 54s22.3858 50 50 50 50-22.3858 50-50ZM71 38 38 71M71 71 38 38"
                                stroke="#CD3029"/>
                        </svg>
                    }

                    {/* message */}
                    {this.props.spinnerText &&
                        <p>{this.props.spinnerText}</p>
                    }
                </div>
            </div>
        )
    }
}
